module.exports = __webpack_public_path__ + "img/2019homepark-3.0d2c4646.jpeg";